import React from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import BrandLogo from "./BrandLogo";
import { PUBLIC_NAV } from "../lib/publicSite";

function navClass({ isActive }) {
  return `text-sm font-medium transition-opacity hover:opacity-80 ${isActive ? "opacity-100" : "opacity-90"}`;
}

export default function PublicLayout() {
  return (
    <div className="min-h-screen grain-bg flex flex-col">
      <header
        className="sticky top-0 z-20 border-b backdrop-blur-md"
        style={{ borderColor: "var(--border-soft)", background: "rgba(252, 248, 244, 0.92)" }}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
          <BrandLogo to="/" size="md" testid="landing-logo" />
          <nav className="hidden lg:flex items-center gap-7" aria-label="Main">
            {PUBLIC_NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                data-testid={`landing-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={navClass}
                style={{ color: "var(--text-main)" }}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-2 shrink-0">
            <Link to="/login" data-testid="landing-signin-btn" className="text-sm font-medium px-3 py-2 rounded-md hover:bg-[var(--surface-tint)] hidden sm:inline-flex">Sign in</Link>
            <Link to="/register" data-testid="landing-getstarted-btn" className="text-sm font-medium px-4 py-2.5 rounded-md text-white tactile-btn" style={{ background: "var(--primary)" }}>
              Start free trial
            </Link>
          </div>
        </div>
        <nav className="lg:hidden flex overflow-x-auto gap-5 px-6 pb-3 text-sm border-t" style={{ borderColor: "var(--border-soft)" }} aria-label="Main mobile">
          {PUBLIC_NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) => `whitespace-nowrap font-medium py-1 ${isActive ? "underline underline-offset-4" : ""}`}
              style={{ color: "var(--text-main)" }}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="max-w-7xl mx-auto w-full px-6 py-10 text-sm flex flex-wrap items-center justify-between gap-4 border-t" style={{ borderColor: "var(--border-soft)", color: "var(--text-muted)" }}>
        <div>© {new Date().getFullYear()} VastraKiran. Made in India, for India.</div>
        <div className="flex flex-wrap items-center gap-5">
          {PUBLIC_NAV.map((item) => (
            <Link key={item.to} to={item.to} className="hover:opacity-80">{item.label}</Link>
          ))}
          <Link to="/login" data-testid="landing-footer-login">Sign in</Link>
          <Link to="/register" data-testid="landing-footer-register">Start free</Link>
        </div>
      </footer>
    </div>
  );
}
